import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import ArticleCard from "@/components/base/ArticleCard";
import { getLatestArticles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

const tagCloud = [
  "直播间",
  "退费争议",
  "原帖还原",
  "停更",
  "设计稿",
  "探店",
  "滤镜",
  "年度盘点",
  "回应",
  "时间线",
  "关键截图",
  "配方争议",
];

export default function LatestSection() {
  const latest = getLatestArticles(6);

  return (
    <section className="mx-auto max-w-[1400px] px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="LATEST FEED"
        title="最新猛料持续更新"
        description="按发布时间倒序排列，每一条都附有摘要与热度，方便你快速筛出想看的。"
        linkTo="/category/mengliao"
        linkLabel="进入猛料栏目"
      />

      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-8">
          <div className="border-t border-background-200">
            {latest.map((article) => (
              <ArticleCard key={article.id} article={article} variant="list" />
            ))}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="sticky top-24 space-y-6">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-price-tag-3-line text-primary-500" />
                热门标签
              </h3>
              <div className="flex flex-wrap gap-2">
                {tagCloud.map((tag) => (
                  <Link
                    key={tag}
                    to="/category/mengliao"
                    className="whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700 cursor-pointer"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-links-line text-primary-500" />
                栏目直达
              </h3>
              <ul className="space-y-2">
                {categories.map((category) => (
                  <li key={category.slug}>
                    <Link
                      to={`/category/${category.slug}`}
                      className="flex items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600 cursor-pointer"
                    >
                      <span>{category.name}</span>
                      <i className="ri-arrow-right-s-line text-foreground-400" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-accent-300 bg-accent-100 p-5">
              <h3 className="mb-2 flex items-center gap-2 font-heading text-base font-bold text-accent-950">
                <i className="ri-alert-line" />
                理性吃瓜提醒
              </h3>
              <p className="text-sm leading-relaxed text-accent-900">
                聊天记录与单方说法只能说明有人提出主张，不等于事实成立。看到「待核实」标记时，建议先等等另一方的回应。
              </p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}